import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Box,
  Flex,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  Image,
  Button,
  Stack,
  Checkbox,
  InputGroup,
  Input,
  InputRightElement,
  Img,
  HStack,
} from "@chakra-ui/react";
import CloseIconBlack from "../../../assets/images/booking/x-circle.svg";
import chevronLeft from "../../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../../assets/images/employee/chevron-right.svg";
import CloseFile from "../../../assets/images/booking/Frame.svg";
import { useForm } from "react-hook-form";
import { SearchIcon } from "@chakra-ui/icons";
import { apartmentBookingEventLinkCall } from "../../../api/apartmentBookingEventLink";
import PopupImport from "../../../components/popup/PopupImport";
import { exportFile } from "../../../utils/tools";
import toast from "react-hot-toast";
import { useApartmentTable } from "../../../hooks/useApartmentsTable";
import useDebounce from "../../../hooks/useDebounce";
import ReactPaginate from "react-paginate";

const columnMappingReverse = {
  "Mã căn hộ": "code",
  "Tên căn hộ": "name",
  "DT đất": "area",
  "DT xây dựng": "builtUpArea",
  "DT tim tường": "grossFloorArea",
  "DT thông thủy": "areaOfWater",
  "Chiều dài": "length",
  "Chiều rộng": "width",
  "Phòng ngủ": "numberOfBedrooms",
  "Phòng VS": "numberOfToilets",
  Hướng: "directionName",
  "Loại hình căn hộ": "apartmentTypeName",
  "Tính chất": "propertyName",
  "Dự án": "projectName",
  "Mã phân khu": "divisionCode",
  "Giá niêm yết": "totalValue",
  "Giá tính PDV": "priceForCommission",
  "Giá tính phí dịch vụ ước tính": "estimatedServiceFeePrice",
  "% phí dịch vụ nhận từ CĐT": "commissionFromInvestor",
  "% phí dịch vụ trả cho sale": "commissionToSales",
  "% phí dịch vụ nhận từ đối tác ngoài CĐT": "commissionFromPartner",
};

const AddProduct = ({ isOpen, onClose, data, defaultValues, onSubmit }) => {
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const {
    apartmentData,
    refetch,
    // isLoading,
    // isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useApartmentTable(debouncedSearch, defaultValues?.projectId);

  const constantData = apartmentData?.reduce((acc, item) => {
    acc[item.id] = item;
    return acc;
  }, {});
  const [popupVisible, setPopupVisible] = useState(false);

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({
      key: key,
      value: value.name,
      code: value.code,
    }));

  const apartments = useMemo(
    () => formatEntries(constantData),
    [apartmentData],
  );

  const [selectedValues, setSelectedValues] = useState([]);

  const onChangeSearch = useCallback((e) => {
    const { value } = e.target;
    setSearch(value);
  });

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  const fetchData = useCallback(async () => {
    try {
      const dataManagerEmployee =
        await apartmentBookingEventLinkCall.getBookingEventId(
          defaultValues?.id,
        );

      if (dataManagerEmployee?.items) {
        dataManagerEmployee?.items.map((item) => {
          setSelectedValues((prev) => {
            return [...prev, item?.apartmentId];
          });
        });
      }
      refetch();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [defaultValues?.id]);

  useEffect(() => {
    setCurrentPage(1);
    setSelectedValues([]);
    setSearch("");
    if (defaultValues?.id) {
      fetchData();
    } else {
      setSelectedValues([]);
    }
  }, [isOpen, popupVisible]);

  const handleCheckboxChange = (key) => {
    setSelectedValues((prev) => {
      if (prev.includes(key)) {
        return prev.filter((item) => item !== key);
      } else {
        return [...prev, key];
      }
    });
  };

  const { handleSubmit } = useForm({
    defaultValues: defaultValues || {},
  });

  const submitHandler = () => {
    if (Array.isArray(selectedValues) && defaultValues?.id) {
      const list = selectedValues.map((item) => ({
        apartmentId: item,
        bookingEventId: defaultValues?.id,
      }));

      const data = {
        bookingEventId: defaultValues?.id,
        list: list,
      };

      onSubmit(data);
    }
  };

  const handleExportSample = () => {
    const columnMapping = {
      code: "Mã căn hộ",
      name: "Tên căn hộ",
      area: "DT đất",
      builtUpArea: "DT xây dựng",
      grossFloorArea: "DT tim tường",
      areaOfWater: "DT thông thủy",
      length: "Chiều dài",
      width: "Chiều rộng",
      numberOfBedrooms: "Phòng ngủ",
      numberOfToilets: "Phòng VS",
      directionName: "Hướng",
      apartmentTypeName: "Loại hình căn hộ",
      propertyName: "Tính chất",
      projectName: "Dự án",
      divisionCode: "Mã phân khu",
      totalValue: "Giá niêm yết",
      priceForCommission: "Giá tính PDV",
      estimatedServiceFeePrice: "Giá tính phí dịch vụ ước tính",
    };
    const data = [
      {
        code: "AP001",
        name: "Căn hộ APT",
        area: 120,
        builtUpArea: 100,
        grossFloorArea: 20.1,
        areaOfWater: 22.2,
        length: 10,
        width: 12,
        numberOfBedrooms: 3,
        numberOfToilets: 2,
        directionName: "Hướng nam",
        apartmentTypeName: "Hạng sang",
        propertyName: "Loại tính chất 1",
        projectName: "Dự án B",
        divisionCode: "BIET_THU_2",
        totalValue: 2000000000,
        priceForCommission: 50000000,
        estimatedServiceFeePrice: 50000000,
      },
      {
        code: "CH2",
        name: "Căn hộ 22",
        area: 120,
        builtUpArea: 100,
        grossFloorArea: 20.1,
        areaOfWater: 22.2,
        length: 10,
        width: 12,
        numberOfBedrooms: 3,
        numberOfToilets: 2,
        directionName: "Hướng nam",
        apartmentTypeName: "Hạng sang",
        propertyName: "Loại tính chất 1",
        projectName: "Dự án B",
        divisionCode: "BIET_THU_2",
        totalValue: 2000000000,
        priceForCommission: 50000000,
        estimatedServiceFeePrice: 50000000,
      },
    ];
    try {
      exportFile(data, columnMapping, "bang_san_pham_dot_nhan_booking.xlsx");
      refetch();
      toast.success("Download file thành công");
    } catch (error) {
      toast.error("Export lỗi");
      console.log(error);
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent
          backgroundColor="var(--color-main)"
          borderRadius={"16px"}
          h={"85vh"}
          w={"100%"}
          maxW={"625px"}
          overflowY={"auto"}
          sx={{
            "&::-webkit-scrollbar": {
              width: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
              width: "4px",
              borderRadius: "50px",
              background: "var(--color-background)",
            },
            "&::-moz-scrollbar": {
              width: "4px",
            },
            "&::-moz-scrollbar-thumb": {
              width: "4px",
              borderRadius: "50px",
              background: "var(--color-background)",
            },
          }}
        >
          <form
            style={{
              width: "100%",
            }}
            onSubmit={handleSubmit(submitHandler)}
          >
            <Box
              w={"100%"}
              overflowY={"auto"}
              pb={"92px"}
              sx={{
                "&::-webkit-scrollbar": {
                  width: "4px",
                },
                "&::-webkit-scrollbar-thumb": {
                  width: "4px",
                  borderRadius: "50px",
                  background: "var(--color-background)",
                },
                "&::-moz-scrollbar": {
                  width: "4px",
                },
                "&::-moz-scrollbar-thumb": {
                  width: "4px",
                  borderRadius: "50px",
                  background: "var(--color-background)",
                },
              }}
            >
              <Flex flexDirection={"column"} w={"100%"}>
                <Flex
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  gap={"10px"}
                  padding={"25px 24px"}
                  borderBottom={"1px solid var(--bg-line-employee)"}
                >
                  <Text
                    color="var(--color-header-employee)"
                    fontSize={"18px"}
                    fontWeight={"600"}
                  >
                    Thêm sản phẩm vào{" "}
                    {defaultValues?.name || "đợt nhận booking"}
                  </Text>
                  <Box cursor={"pointer"} onClick={onClose}>
                    <Image src={CloseIconBlack} />
                  </Box>
                </Flex>
                <Box flex={1} w={"578px"} m={"24px auto"}>
                  <Text
                    fontSize={"16px"}
                    fontWeight={"600"}
                    lineHeight={"19px"}
                    textTransform={"uppercase"}
                    mb={"12px"}
                  >
                    {defaultValues?.projectName || "Tên dự án"}
                  </Text>
                  <InputGroup
                    borderRadius={{ base: "8px" }}
                    w={{ base: "100%" }}
                  >
                    <Input
                      placeholder="Nhập mã căn hộ, tên căn hộ,..."
                      type="text"
                      borderRadius={{ base: "8px" }}
                      border={{ base: "1px solid var(--color-boder)" }}
                      backgroundColor={"var(--fill-avatar)"}
                      onChange={onChangeSearch}
                    />
                    <InputRightElement
                      borderTopRightRadius={"8px"}
                      borderBottomRightRadius={"8px"}
                      pointerEvents="none"
                      cursor={"pointer"}
                      backgroundImage="var(--color-button)"
                    >
                      <SearchIcon color="var(--color-main)" />
                    </InputRightElement>
                  </InputGroup>
                  <Box mt={"24px"}>
                    <Stack gap={"12px"} flexWrap={"wrap"} flexDirection={"row"}>
                      {apartments.map((item, key) => (
                        <Checkbox
                          key={key}
                          p={"16px 20px"}
                          gap={"24px"}
                          fontSize={"14px"}
                          lineHeight={"17px"}
                          fontWeight={"500"}
                          maxW={"283px"}
                          w={"100%"}
                          border={"1px solid var(--color-boder)"}
                          borderRadius={"8px"}
                          onChange={() => handleCheckboxChange(item.key)}
                          isChecked={selectedValues.includes(item.key)}
                        >
                          <Flex gap={"4px"}>
                            <Text fontSize={"14px"} fontWeight={"500"}>
                              Mã Căn:
                            </Text>
                            <Text fontSize={"14px"} fontWeight={"400"}>
                              {item.code ? `${item.code}` : ``}
                            </Text>
                          </Flex>
                          <Flex mt={"4px"} gap={"4px"}>
                            <Text fontSize={"14px"} fontWeight={"500"}>
                              Tên:
                            </Text>
                            <Text fontSize={"14px"} fontWeight={"400"}>
                              {item.value}
                            </Text>
                          </Flex>
                        </Checkbox>
                      ))}
                    </Stack>
                    <Box mt={10} mr={5} mb={5} ml={5}>
                      <Flex
                        alignItems={"center"}
                        justifyContent={"space-between"}
                      >
                        <Text>
                          Showing {startEntry} to {endEntry} of {entries}{" "}
                          entries
                        </Text>
                        <HStack spacing={2} justify="flex-end">
                          <ReactPaginate
                            className="pagination-custom"
                            pageCount={totalPages}
                            pageRangeDisplayed={3}
                            marginPagesDisplayed={1}
                            onPageChange={handlePageChange}
                            containerClassName={"pagination"}
                            activeClassName={"active"}
                            breakClassName={"ellipsis"}
                            breakLabel={"..."}
                            previousLabel={
                              <Img
                                w={"16px"}
                                minW={"16px"}
                                h={"16px"}
                                src={chevronLeft}
                              />
                            }
                            nextLabel={
                              <Img
                                w={"16px"}
                                minW={"16px"}
                                h={"16px"}
                                src={chevronRight}
                              />
                            }
                            renderOnZeroPageCount={null}
                            forcePage={currentPage - 1}
                          />
                        </HStack>
                      </Flex>
                    </Box>
                  </Box>
                </Box>
                <Box
                  // position={"fixed"}
                  // bottom={"40px"}
                  w={"100%"}
                  borderTop={" 0.5px solid var(--border-input-employee)"}
                  maxWidth={"625px"}
                >
                  <Flex
                    w={"100%"}
                    bg={"var(--color-main)"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    p={"24px"}
                    borderBottomLeftRadius={"8px"}
                    borderBottomRightRadius={"8px"}
                  >
                    <Button
                      display="flex"
                      alignItems="center"
                      p="10px 16px"
                      h={"44px"}
                      gap="8px"
                      backgroundImage="var(--color-button)"
                      onClick={() => setPopupVisible(true)}
                      _hover={{
                        filter: "brightness(90%)",
                      }}
                    >
                      <Image src={CloseFile} />
                      <Text
                        fontSize="15px"
                        fontWeight={600}
                        color="var(--color-main)"
                      >
                        Tải file lên
                      </Text>
                    </Button>
                    <Flex gap={"16px"} justifyContent={"flex-end"}>
                      <Button
                        w={"112px"}
                        h={"44px"}
                        color={"var(--color-option-employee-hover)"}
                        border={"1px solid var(--color-option-employee-hover)"}
                        bg={"var(--color-main)"}
                        onClick={onClose}
                        _hover={{
                          filter: "brightness(90%)",
                        }}
                      >
                        Hủy
                      </Button>
                      <Button
                        type="submit"
                        w={"112px"}
                        h={"44px"}
                        color={"var(--color-main)"}
                        bg={"var(--color-button)"}
                        _hover={{
                          filter: "brightness(80%)",
                        }}
                      >
                        Xong
                      </Button>
                    </Flex>
                  </Flex>
                </Box>
              </Flex>
            </Box>
          </form>
        </ModalContent>
      </Modal>
      {popupVisible && (
        <PopupImport
          isOpen={popupVisible}
          onClose={() => setPopupVisible(false)}
          refetchCheckInData={fetchData}
          columnMappingReverse={columnMappingReverse}
          handleExport={handleExportSample}
          titleAdd="Thêm danh sách sản phẩm"
          inputAdd="Nhập danh sách sản phẩm"
          type={"apartmentBookingEventLink"}
          id={defaultValues?.id}
          isTypePrice={true}
        />
      )}
    </>
  );
};

export default AddProduct;
